import styled from 'styled-components';
import BackgroundImage from 'assets/svg/bg_login_portal_client_grey.svg';

export const BgLogin = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  padding: 18px 20px;
  @media only screen and (max-width: 1440px) {
    padding: 15px;
  }
`;
export const TopWindows = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
`;
export const First = styled.div`
  width: 33%;
  margin-right: 10px;
  @media only screen and (max-width: 960px) {
    width: 100%;
    margin-right: 0;
  }
`;
export const BottomWindows = styled.div`
  display: flex;
  margin-top: 12px;
  width: 100%;
  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
`;
